<div class="log-dialog">
  <div class="header">
    <div class="row">
      <div class="col-12">
        <h1 mat-dialog-title class="dialog-title">{{title}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="break-line-1"></div>
      </div>
    </div>
    <div class="row number-indicator">
      <div class="col-6 ">
        <p><span class="handled">{{numberOfHandled}}</span> Hanterade</p>
      </div>
      <div class="col-6">
        <p><span class="unhandled">{{numberOfUnhandled}}</span> Icke hanterade</p>
      </div>
    </div>
  </div>
  <mat-dialog-content class="article">
    <div class="row">
      <div class="col-12">
        <div class="table-headers row g-0">
          <div class="col-3 table-cell">Datum</div>
          <div class="col-3 table-cell">Användare</div>
          <div class="col-3 table-cell">Meddelande</div>
          <div class="col-3 table-cell">Hanterad</div>
        </div>
        <div class="log-table-view">
          <div class="table-row row g-0" *ngFor="let log of filteredLogList" [ngClass]="{'unhandled': !log.resolved}">
            <div class="col-3 table-cell" >{{getDate(log)}}</div>
            <div class="col-3 table-cell" >{{log.affectedResourceName}}</div>
            <div class="col-3 table-cell" >{{log.message}}</div>
              <div class="col-3 table-cell" *ngIf="showResolveButton(log)">
                <mat-checkbox class="resolved-checkbox checkbox-hide" [checked]="log.resolved" (change)="addToModifiedLogList(log.id, $event)"></mat-checkbox>
                <span class="resolvedBy-message" *ngIf="log.resolved">Hanterad av</span><span class="resolvedBy-user" *ngIf="log.resolved">{{log.updatedBy}}</span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <div class="footer">
    <div class="row">
      <div class="col-12">
        <div class="break-line-2"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-checkbox class="handled-checkbox checkbox-hide" [checked]="showHandled" (change)="toggleShowHandled()">Visa alla</mat-checkbox>
      </div>
      <div class="col-3">
        <button mat-button type="button" class="s-button dark_blue_border" mat-dialog-close>
          Stäng
        </button>
      </div>
      <div class="col-6">
        <button mat-button type="submit" class="s-button dark_blue" [disabled]="!canSave()" (click)="updateResolvedState()">
          Spara
        </button>
      </div>
    </div>
  </div>
</div>
